export * from './webhosting-setup-template';
